import { App as AntdApp, ConfigProvider, ThemeConfig } from "antd";
import zhCN from "antd/locale/zh_CN";

import { RouterProvider } from "@tanstack/react-router";
import { router } from "@/router/router";

const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: "#FF593E",
    colorLink: "#FF593E",
    borderRadius: 4,
    borderRadiusLG: 4,
    borderRadiusSM: 4,
    borderRadiusXS: 2,
  },
};

export const App = () => {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={antdTheme}
      getPopupContainer={() => document.querySelector("#root") as HTMLElement}
      getTargetContainer={() => document.querySelector("#root") as HTMLElement}
    >
      <AntdApp>
        <RouterProvider router={router} />
      </AntdApp>
    </ConfigProvider>
  );
};
